module.exports = __webpack_public_path__ + "static/desktop/img/design-tablet-photobook.e7d769dd.png";